<ncp-table #allergies [(options)]="options"></ncp-table>
